var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickbooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 4050 4050",
    viewBox: "0 0 4050 4050",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m452 1874.4c.15 423.9 342 768.6 765.9 772.35h108.45v-283.35h-108.45c-262.8 71.7-533.85-83.25-605.4-346.05-.6-2.1-1.05-4.2-1.65-6.3-73.65-266.25 80.55-542.1 345.9-618.75h54.15c67.95-14.85 138.3-14.85 205.95 0h263.4v1504.35c-1.35 159.15 126.6 289.35 285.75 290.85v-2093.1h-546.75c-426.9 2.25-771 350.1-768.75 777v.15zm2081.25-779.7h-108.45v298.35h108.45c262.2-71.55 532.65 82.95 604.2 345 .6 1.95 1.05 4.05 1.65 6 73.2 265.35-80.55 540.15-344.85 616.65h-54.15c-67.95 14.85-138.3 14.85-205.95 0h-263.4v-1504.2c1.35-159.15-126.6-289.35-285.75-290.85v2096.1h546.75c430.65-6.75 774.3-361.2 767.7-791.85-6.6-421.2-346.35-761.1-767.7-767.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickbooks);
export default __webpack_public_path__ + "static/media/quickbooks.0ada8f8420f52dc397297301f5052a2b.svg";
export { ForwardRef as ReactComponent };